import {connect, useSelector} from "react-redux";

export const useAwsPostAIJustPaidGuard = (route=null) => {
    const user = useSelector(state => state.users.user)
    const awsSubscription = user?.all_aws_post_ai_live_subscriptions;
    // console.log("AWS AWS", awsSubscription)

    /**just for the team*/
    const specialPermission = user?.copilotAccess ? user?.copilotAccess['postAITeam'] : false;

    return awsSubscription ? !awsSubscription.subscription_expired : specialPermission;
}
